module.exports = __webpack_public_path__ + "img/the-spa-suite-img.01f8d6a7.jpg";